// extracted by mini-css-extract-plugin
export default {"loading":"BlockWithLoading_loading__+l5QV","loadingWithBackground":"BlockWithLoading_loadingWithBackground__AugX2"};